var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSoundMid = function SvgSoundMid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.388 1.75v20.753l-8.135-6.1h-4.98V7.85h4.98l8.135-6.101Zm-1.25 2.5L6.67 9.1H2.523v6.052H6.67l6.468 4.851V4.25ZM16.515 8.4a.625.625 0 0 1 .884 0c2.07 2.069 2.07 5.294 0 7.364a.625.625 0 1 1-.884-.884c1.581-1.582 1.581-4.015 0-5.597a.625.625 0 0 1 0-.884Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.162 5.935a.625.625 0 0 1 .884 0c3.438 3.439 3.438 9.037 0 12.476a.625.625 0 1 1-.884-.884c2.95-2.95 2.95-7.758 0-10.708a.625.625 0 0 1 0-.884Z",
    fill: "currentColor"
  })));
};
export default SvgSoundMid;